import CampaignReportsActionTypes from './types';

export const fetchCampaignGiftReportsStart = campaignId => ({
  type: CampaignReportsActionTypes.FETCH_CAMPAIGN_GIFT_REPORTS_START,
  payload: campaignId,
});

export const fetchCampaignGiftReportsSuccess = gifts => ({
  type: CampaignReportsActionTypes.FETCH_CAMPAIGN_GIFT_REPORTS_SUCCESS,
  payload: gifts,
});

export const fetchGiftWinnersStart = (campaignId, giftId) => ({
  type: CampaignReportsActionTypes.FETCH_GIFT_WINNERS_START,
  payload: { campaignId, giftId },
});

export const fetchGiftWinnersSuccess = winners => ({
  type: CampaignReportsActionTypes.FETCH_GIFT_WINNERS_SUCCESS,
  payload: winners,
});

export const exportCouponsStart = (from, to, campaignId) => ({
  type: CampaignReportsActionTypes.EXPORT_COUPONS_START,
  payload: { from, to, campaignId },
});

export const setCampaignReportsState = state => ({
  type: CampaignReportsActionTypes.SET_CAMPAIGN_REPORTS_STATE,
  payload: state,
});
